// @flow
import styled from "styled-components";
import { blogWrapperStyles } from "../../../components/Blog/Breadcrumbs";
import { RichText } from "../../../components/Blog/RichText";

const Wrapper = styled.div`
  max-width: 1140px;
  margin: auto;
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 40px;
  }
`;

type Props = {
  content: PrismicRichText,
};

const Text = ({ content }: Props) => (
  <div css={blogWrapperStyles}>
    <Wrapper>
      <RichText>{content}</RichText>
    </Wrapper>
  </div>
);

export { Text };
